module.exports = __webpack_public_path__ + "static/media/4-BIM市政计量GMA.b4cb6f1b.png";